import {makeVar, useReactiveVar} from "@apollo/client";

export const openStateAvatarModal = makeVar<boolean>(false)

export const useAvatarModal = (): [boolean, (open: boolean) => void] => {

  const setOpen = (open) => {
    openStateAvatarModal(open)
  }

  return [useReactiveVar<boolean>(openStateAvatarModal), setOpen]
}
